<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories" style="color:black">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                Справочники
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <div class="title">Запас времени</div>
                    </div>
                    <table cellpadding="0" cellspacing="0" class="leeway-table">
                      <thead>
                      <tr>
                        <td>Наименование</td>
                        <td>Запас времени, час./мин.</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr title="Изменить" v-for="leeway in leewayList"
                          @click="$router.push('/directories/leeway/' + leeway.id)">
                        <td class="name">{{ leeway.name }}</td>
                        <td>{{ prepareTime(leeway.time) }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'
    import utils from '@/utils'

    export default {
  name: 'LeewayTable',
  components: {
    MenuDispatcher,
    HeaderDispatcher
  },

  data () {
    return {
      leewayList: []
    }
  },

  methods: {
    prepareTime (time) {
      return utils.getFormattedTimeStringFromLongWithoutTimezone((new Date()).setHours(0, 0, 0, 0) + (time))
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    api
      .getLeeway()
      .then(leewayList => {
        if (leewayList) {
          this.leewayList = []
          this.leewayList = leewayList
        }
      })
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  }
}
</script>
